/**
 * Centralized brand color constants for the onboarding / wizard UI.
 *
 * Previously these hex values were scattered across 30+ files.
 * Import from here so a single change updates the whole app.
 */

// ---------------------------------------------------------------------------
// Raw palette
// ---------------------------------------------------------------------------

/** Primary brand purple */
export const BRAND_PRIMARY = '#667eea';
/** Secondary brand purple (gradient end) */
export const BRAND_SECONDARY = '#764ba2';
/** Primary hover / pressed state */
export const BRAND_PRIMARY_HOVER = '#5a6fd6';
/** Secondary hover / pressed state */
export const BRAND_SECONDARY_HOVER = '#6a4190';

// ---------------------------------------------------------------------------
// Pre-built gradients (most common patterns)
// ---------------------------------------------------------------------------

/** Diagonal gradient used on headers, banners, hero cards */
export const BRAND_GRADIENT_135 = `linear-gradient(135deg, ${BRAND_PRIMARY} 0%, ${BRAND_SECONDARY} 100%)`;
/** Horizontal gradient used on buttons and progress bars */
export const BRAND_GRADIENT_90 = `linear-gradient(90deg, ${BRAND_PRIMARY} 0%, ${BRAND_SECONDARY} 100%)`;
/** Hover state for the horizontal button gradient */
export const BRAND_GRADIENT_90_HOVER = `linear-gradient(90deg, ${BRAND_PRIMARY_HOVER} 0%, ${BRAND_SECONDARY_HOVER} 100%)`;
/** Hover state for the diagonal gradient */
export const BRAND_GRADIENT_135_HOVER = `linear-gradient(135deg, ${BRAND_PRIMARY_HOVER} 0%, ${BRAND_SECONDARY_HOVER} 100%)`;

// ---------------------------------------------------------------------------
// Alpha / translucent variants
// ---------------------------------------------------------------------------

/** Very subtle background tint (4% opacity) */
export const BRAND_PRIMARY_4 = 'rgba(102,126,234,0.04)';

// Hex+alpha shorthand variants (used in inline styles)
/** ~6% opacity */
export const BRAND_PRIMARY_10 = `${BRAND_PRIMARY}10`;
/** ~8% opacity */
export const BRAND_PRIMARY_15 = `${BRAND_PRIMARY}15`;
/** ~12% opacity */
export const BRAND_PRIMARY_20 = `${BRAND_PRIMARY}20`;
/** ~13% opacity */
export const BRAND_PRIMARY_22 = `${BRAND_PRIMARY}22`;
/** ~19% opacity */
export const BRAND_PRIMARY_30 = `${BRAND_PRIMARY}30`;
/** ~8% opacity secondary */
export const BRAND_SECONDARY_15 = `${BRAND_SECONDARY}15`;
/** ~13% opacity secondary */
export const BRAND_SECONDARY_22 = `${BRAND_SECONDARY}22`;

// ---------------------------------------------------------------------------
// Reusable MUI sx helpers
// ---------------------------------------------------------------------------

/** Standard sx for a gradient CTA button */
export const brandButtonSx = {
  background: BRAND_GRADIENT_90,
  '&:hover': { background: BRAND_GRADIENT_90_HOVER },
} as const;
